import React from "react";
import { Link } from "react-router-dom";
import "./About.css";
import resume from "./Andrew_Lee_Resume.pdf";
import me from "./Images/DSC01034.png";

export default function About() {
  return (
    <div className="about-div">
      <h2 className="about-heading">About</h2>
      <section className="bio">
        <img src={me} alt="Andrew Lee portrait" />
        <h1 className="bio-name">Andrew Lee</h1>
        <p>
          Email: <a href="mailto:alee14@bu.edu">alee14@bu.edu</a>
        </p>
        <p>
          <a href={resume} target="_blank" rel="noopener noreferrer">
            Resume
          </a>
        </p>
        <p className="bio-desc">
          Currently a Software Engineer at Fidelity. I am interested in cloud
          computing, AI, and embedded system programming. When I am not coding,
          I like to skateboard, throw clay, and cook!
        </p>
      </section>
    </div>
  );
}
